module.exports = __webpack_public_path__ + "static/media/icon_capsule.ff984197.svg";